import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-remove',
  templateUrl: './icon-account-remove.component.html',
  styleUrl: './icon-account-remove.component.scss',
  standalone: false,
})
export class IconAccountRemoveComponent {
  @Input() tooltip?: string;
}
